<template>
  <div class="page-wrap">
    <div class="session-form-hold">
      <base-card v-if="user_id != '' && user_id != -1">
        <v-card-text class="text-center">
          <v-avatar size="60" class="mb-4">
            <img src="@/assets/images/logo.svg" alt="" />
          </v-avatar>
          <p class="text--disabled font-weight-medium mb-10">{{ header }}</p>
          <v-text-field
            label="Password"
            v-model="password"
            type="password"
            :error-messages="passwordErrors"
            required
            @input="$v.password.$touch()"
            @blur="$v.password.$touch()"
          ></v-text-field>
          <v-text-field
            label="Confirm Password"
            v-model="cPassword"
            type="password"
            :error-messages="cPasswordErrors"
            required
            @input="$v.cPassword.$touch()"
            @blur="$v.cPassword.$touch()"
          ></v-text-field>
          <v-btn class="mt-2 mb-4" block color="primary" @click="setPassword()"
            >Submit</v-btn
          >
          <div class="d-flex justify-around">
            <v-btn text small color="primary" :to="{ name: 'login' }"
              >Sign in to Portal</v-btn
            >
          </div>
        </v-card-text>
      </base-card>
      <base-card v-else-if="user_id == -1">
        <v-card-text class="text-center">
          <v-avatar tile size="120">
            <img src="@/assets/images/svg/warning.svg" alt="" />
          </v-avatar>
          <br />
          <span class="text--disabled font-weight-bold">Token is expired.</span>
        </v-card-text>
      </base-card>

      <v-card-text v-else class="text-center">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-card-text>
    </div>
    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="timeout">
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn dark icon v-bind="attrs" @click="snackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<script>
import { BASEURL } from "@/api/baseurl";
import axios from "axios";
import { validationMixin } from "vuelidate";
import { required, minLength, sameAs } from "vuelidate/lib/validators";

export default {
  name: "Forgot",
  metaInfo: {
    // title will be injected into parent titleTemplate
    title: "Forgot",
  },
  mixins: [validationMixin],

  data() {
    return {
      domain: BASEURL,
      key: this.$route.params.key,
      user_id: "",
      type: "",
      reset_password_id: "",
      password: "",
      cPassword: "",
      snackbar: false,
      text: "",
      snackbarColor: "",
      timeout: 1900,
    };
  },

  validations: {
    password: { required, minLength: minLength(6) },
    cPassword: {
      sameAsPassword: sameAs("password"),
    },
  },

  watch: {},
  computed: {
    header() {
      return this.type == 0
        ? "Setting Your Account Password"
        : "Forgot Password";
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required && errors.push("Password is required");
      !this.$v.password.minLength &&
        errors.push("Password is at least 6 character");
      return errors;
    },
    cPasswordErrors() {
      const errors = [];
      if (!this.$v.cPassword.$dirty) return errors;
      !this.$v.cPassword.sameAsPassword &&
        errors.push("Comfirm Password is not match");
      return errors;
    },
  },
  created() {
    this.readResetPassword();
  },
  methods: {
    readResetPassword() {
      const params = new URLSearchParams();
      params.append("readResetPassword", "done");
      params.append("key", this.key);

      axios({
        method: "post",
        url: this.domain + "/email/index.php",
        data: params,
      })
        .then((response) => {
          console.log(response);
          if (response.data.status == "1") {
            this.user_id = response.data.email[0].user_id;
            this.type = response.data.email[0].type;
            this.reset_password_id = response.data.email[0].reset_password_id;
          } else {
            this.user_id = -1;
            this.type = "";
            this.reset_password_id = "";
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    setPassword() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const params = new URLSearchParams();
        params.append("setPassword", "done");
        params.append("user_id", this.user_id);
        params.append("password", this.password);
        params.append("reset_password_id", this.reset_password_id);

        axios({
          method: "post",
          url: this.domain + "/email/index.php",
          data: params,
        })
          .then((response) => {
            console.log(response);
            if (response.data.status == "1") {
              this.text =
                "Successfully set your password. Now will redirect you to login page";
              this.snackbar = true;
              this.snackbarColor = "success";
              setTimeout(() => {
                this.$router.push({ name: "login" });
              }, 2000);
            } else {
              this.text = "Something went wrong. Please try again later";
              this.snackbar = true;
              this.snackbarColor = "error";
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.page-wrap {
  background-color: #242939 !important;
  display: flex;
  align-items: center;
  padding: 40px 1rem;
  height: 100%;
  min-height: 100vh;
}
.session-form-hold {
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
}
</style>
